import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "nav",
  "data-responsive-menu": "accordion"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("АВИАБИЛЕТЫ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Ж/Д БИЛЕТЫ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" БРОНИРОВАНИЕ ОТЕЛЕЙ ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("УСЛУГИ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("КОМАНДИРОВКИ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    _createVNode("li", null, [
      _createVNode(_component_router_link, {
        class: { 'active': _ctx.activePath('avia') },
        to: _ctx.aviaSearch
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class", "to"])
    ]),
    _createVNode("li", null, [
      _createVNode(_component_router_link, {
        class: { 'active': _ctx.activePath('rail') },
        to: _ctx.railSearch
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["class", "to"])
    ]),
    _createVNode("li", null, [
      _createVNode(_component_router_link, {
        to: _ctx.hotelSearch,
        class: { 'active': _ctx.activePath('hotel') }
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to", "class"])
    ]),
    _createVNode("li", null, [
      _createVNode(_component_router_link, {
        class: { 'active': _ctx.activePath('service') },
        to: _ctx.service
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["class", "to"])
    ]),
    _createVNode("li", null, [
      _createVNode(_component_router_link, {
        class: { 'active': _ctx.activePath('trip') },
        to: _ctx.trips
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["class", "to"])
    ])
  ]))
}